import React from "react";
import { profile } from "../data/profile";

const Hero = () => (
  <section
    id="top"
    className="mx-auto max-w-content px-6 pb-10 pt-12 md:pb-14 md:pt-16"
  >
    <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-line bg-surface px-3 py-1.5 font-mono text-xs text-muted">
      <span
        className="h-2 w-2 rounded-full bg-live motion-safe:animate-pulse"
        aria-hidden="true"
      />
      {profile.availability} · {profile.location}
    </p>

    <h1 className="text-4xl font-bold tracking-tight md:text-6xl">
      hey, I'm {profile.name}.
    </h1>
    <p className="mt-4 text-xl font-semibold text-fg md:text-2xl">
      {profile.role}
    </p>
    <p className="mt-4 max-w-prose text-muted">{profile.summary}</p>

    <div className="mt-8 flex flex-wrap items-center gap-3">
      <a
        href={profile.resume}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full border border-line px-6 py-3 text-sm font-semibold transition-colors duration-100 hover:border-fg active:translate-y-px"
      >
        Resume
      </a>
      <a
        href={`mailto:${profile.email}`}
        className="rounded-full px-4 py-3 text-sm font-medium text-muted underline-offset-4 transition-colors duration-100 hover:text-fg hover:underline"
      >
        {profile.email}
      </a>
    </div>

    <ul className="mt-10 flex flex-wrap gap-x-5 gap-y-2">
      {profile.socials.map((social) => (
        <li key={social.label}>
          <a
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="py-2 font-mono text-xs text-faint underline-offset-4 transition-colors duration-100 hover:text-fg hover:underline"
          >
            {social.label} ↗
          </a>
        </li>
      ))}
    </ul>
  </section>
);

export default Hero;
